<template>
    <div id="app">
        <Header/>
        <Sidebar/>
        <router-view/>
        <Footer/>
        <ContactForm/>
        <div class="foot-contact">
            <a class="link plr-xs" @click="toggleContact(1)">{{ $common.config.lang === 'cn' ? '免费试用' : 'Download Demo' }}</a>
            <Divider type="vertical"/>
            <a class="btn ml-xs" @click="toggleContact(2)">
                <Icon type="ios-call" size="18"/>
            </a>
            <a class="btn ml-xs" @click="toggleContact(3)">
                <Icon type="ios-chatbubbles" size="18"/>
            </a>
        </div>
    </div>
</template>

<script type="text/javascript">
    import Header from '@/components/Header';
    import Sidebar from "./components/Sidebar";
    import Footer from "@/components/Footer";
    import ContactForm from "./components/ContactForm";

    export default {
        name: 'App',
        components: {
            Header, Sidebar, Footer, ContactForm
        },
        async created(){
            // 初始：设置语言为中文
            if (!localStorage.getItem('lang')){
                localStorage.setItem('lang', this.$common.config.lang);
            }
        },
        async mounted () {
            await this.$common.product();
            await this.$common.solution();

            await this.replacePage();
        },
        methods: {
            // 重定向页面
            async replacePage(){
                if (this.$common.config.navigation[0].children.length > 0){
                    await this.$router.replace({
                        path: '/product',
                        query: {
                            id: this.$common.config.navigation[0].children[0].id,
                        }
                    });
                } else {
                    await window.VUE.$common.alertModel('error', '英文版内容暂未填充，点击确定返回中文版');
                }
            },
            toggleContact(type){
                console.log('this.toggleContact---------->', type);
                this.$bus.emit('toggleContact', true, type);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue